export const MENTORSHIP_TIMELINES = [
    { value: "no_timeline", label: "I don't have a specific timeline." },
    { value: "few_weeks", label: "Within the next few weeks." },
    { value: "one_month", label: "In about a month." },
    { value: "three_months", label: "Over the next three months." },
    { value: "six_months", label: "In around six months." },
    { value: "one_year", label: "In a year or more." },
  ] as const;
